module.exports = __webpack_public_path__ + "static/media/logo.8abf5c09.png";